import tuner from '../tuner';
import webApiClientSingleton from '../webApiClientSingleton';

// eslint-disable-next-line import/prefer-default-export
export function sendTimingEvent(measureName, measureStart) {
  webApiClientSingleton.instance.logging.infoLog({
    message: 'tuner.performance.info',
    context: {
      name: measureName,
      timing: performance.now() - measureStart,
      guideId: tuner.tune.guideId,
      listenId: tuner.tune.listenId,
    },
  });
}
